import React from 'react';
import SettingsIcon from '@mui/icons-material/Settings';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Box } from '@mui/material';
import { CustomTablePagination } from 'components/Table';
import * as S from '../../styles';
import { BUTTONS, DIALOGS } from '../../TransportCloudTable.consts';

interface TableControlsProps {
  rowsPerPageOptions: number[];
  count: number;
  rowsPerPage: number;
  page: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number,
  ) => void;
  onRowsPerPageChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  onOpenDialog: () => void;
  onOpenManagementDialog: () => void;
  showIcon?: 'visibility' | 'visibility-off';
  showManagementButton?: boolean;
}

export const TableControls: React.FC<TableControlsProps> = ({
  rowsPerPageOptions,
  count,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
  onOpenDialog,
  onOpenManagementDialog,
  showIcon = 'visibility',
  showManagementButton = true,
}) => {
  const Icon = showIcon === 'visibility' ? VisibilityIcon : VisibilityOffIcon;

  return (
    <S.FixedPaginationContainer>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <S.ViewSettingsButton startIcon={<Icon />} onClick={onOpenDialog}>
          {BUTTONS.viewSettings}
        </S.ViewSettingsButton>
        {showManagementButton && (
          <S.ViewSettingsButton
            startIcon={<SettingsIcon />}
            onClick={onOpenManagementDialog}
          >
            {DIALOGS.cloudManagement}
          </S.ViewSettingsButton>
        )}
      </Box>
      <Box
        sx={{
          '& .MuiAutocomplete-root .MuiInputBase-input': {
            fontSize: '0.7rem',
            padding: '3px 4px !important',
          },
          '& .MuiAutocomplete-root .MuiOutlinedInput-root': {
            padding: `1px 28px 1px 2px !important`,
            fontSize: '0.7rem',
          },
          '& .MuiAutocomplete-root .MuiSvgIcon-root': {
            fontSize: '14px',
          },
          '& .MuiAutocomplete-endAdornment': {
            top: 'calc(50% - 10px)',
          },
        }}
      >
        <CustomTablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          compactPagePicker
          SelectProps={{
            MenuProps: {
              sx: {
                '& .MuiMenuItem-root': {
                  fontSize: '0.7rem',
                  minHeight: 'auto',
                  padding: '4px 12px',
                },
              },
            },
          }}
          sx={{
            '& .MuiTablePagination-toolbar': {
              minHeight: 0,
              padding: '0 9px',
            },
            '& .MuiTablePagination-selectLabel': {
              fontSize: '0.7rem',
              margin: 0,
            },
            '& .MuiTablePagination-select': { fontSize: '0.7rem' },
            '& .MuiTablePagination-displayedRows': {
              fontSize: '0.7rem',
              margin: 0,
            },
            '& .MuiIconButton-root': { padding: '3px' },
            '& .MuiSvgIcon-root': { fontSize: '16px' },
          }}
        />
      </Box>
    </S.FixedPaginationContainer>
  );
};
